import { Component, OnInit } from '@angular/core';

class model{
}

@Component({
	templateUrl: './attendance.component.html',
	styleUrls: ['./attendance.component.css']
})

export class AttendanceComponent implements OnInit {
	public m: model;
	ngOnInit() {
		this.m = new model();
	}
}


// WEBPACK FOOTER //
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/academics/attendance.component.ts